/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Badge_UnknownInputs */

const vi_einvoice_badge_unknown = /** @type {(inputs: Einvoice_Badge_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa xác định trạng thái hóa đơn`)
};

/**

* @param {Einvoice_Badge_UnknownInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_badge_unknown = /** @type {((inputs?: Einvoice_Badge_UnknownInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Badge_UnknownInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_badge_unknown(inputs)
});